


















import { Vue, Component, Watch, Prop } from "vue-property-decorator"
import { Howl } from "howler"
@Component
export default class MoneyView extends Vue {
  public notifications: number = 0
  public oldMoney: number = 0
  public newMoney: number = 0
  @Prop(Boolean) protected unfocus: boolean
  get money() {
    return this.$store.state.money
  }

  @Watch("money")
  public displayNotification(oldVal: number, newVal: number) {
    this.oldMoney = oldVal
    this.newMoney = newVal
    this.notifications++
    if (!this.$store.state.muted) {
      if (this.oldMoney - this.newMoney >= 0) {
        new Howl({
          src: ["/audio/Money gained.mp3"]
        }).play()
      } else {
        new Howl({
          src: ["/audio/Money lost.mp3"]
        }).play()
      }
    }
  }
}
